import { useWishlistSync } from '@pco/api/mesh/wishlist/useWishlistSync';
import { useQueryClient } from '@pco/api/react-query';
import { useCustomerData } from '@pco/utils/useCustomerData';
import { useEffect } from 'react';

/**
 * Syncs guest wishlist items from sessionStorage to the user's account
 * whenever the user logs in.
 *
 * If there are any items stored in sessionStorage under 'likedItems',
 * they will be added to the user's wishlist in a single batch for better performance.
 * After syncing, the 'likedItems' key is cleared from sessionStorage.
 */
export const SyncGuestWishlistOnLogin = () => {
	const queryClient = useQueryClient();
	const { data: customerData } = useCustomerData();
	const { addProductsToWishlist } = useWishlistSync();

	useEffect(() => {
		if (!customerData?.customer) return;

		const syncGuestWishlist = async () => {
			try {
				const likedItems = JSON.parse(
					sessionStorage.getItem('likedItems') || '[]',
				) as string[];

				if (!likedItems.length) return;

				const items = likedItems.map((sku) => ({ sku, quantity: 1 }));

				await addProductsToWishlist(items);

				sessionStorage.removeItem('likedItems');
				queryClient.invalidateQueries({ queryKey: ['Customer'] });
			} catch (error) {
				console.error('Failed to sync guest wishlist:', error);
			}
		};

		syncGuestWishlist();
	}, [customerData, addProductsToWishlist, queryClient]);

	return null;
};

export default SyncGuestWishlistOnLogin;
